import { cn } from "src/common/utils";

const ElasticIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1")}>
    <svg
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M123.94 64.9995C123.94 54.6221 117.521 45.5026 107.803 42.0232C108.222 39.8043 108.402 37.6447 108.402 35.3651C108.402 16.0475 92.6854 0.330475 73.4284 0.330475C62.0899 0.330475 51.6519 5.72945 45.0531 14.8477C41.8137 12.3282 37.8532 10.9491 33.7146 10.9491C23.4559 10.9491 15.1181 19.2869 15.1181 29.5456C15.1181 31.8252 15.5374 33.9847 16.2573 36.0243C6.59851 39.5037 -0.000244141 48.7432 -0.000244141 59.0612C-0.000244141 69.4993 6.47853 78.6176 16.1979 82.0969C15.7774 84.2565 15.598 86.4767 15.598 88.7563C15.598 108.013 31.2545 123.671 50.5115 123.671C61.8499 123.671 72.288 118.211 78.8274 109.093C82.0667 111.672 86.026 113.052 90.1658 113.052C100.423 113.052 108.762 104.713 108.762 94.4546C108.762 92.175 108.342 90.0154 107.622 87.9758C117.341 84.5571 123.94 75.3188 123.94 64.9995Z"
        fill="white"
      />
      <path
        d="M48.7724 53.4817L75.8873 65.8394L103.243 41.8439C103.663 39.8636 103.843 37.944 103.843 35.845C103.843 18.9876 90.1052 5.24956 73.2478 5.24956C63.1697 5.24956 53.7509 10.2292 48.0525 18.567L43.4934 42.1432L48.7724 53.4817Z"
        fill="#FED10A"
      />
      <path
        d="M20.6966 82.1575C20.2773 84.1365 20.0967 86.1761 20.0967 88.2764C20.0967 105.193 33.8941 118.931 50.7515 118.931C60.8902 118.931 70.3684 113.892 76.068 105.553L80.5665 82.0375L74.5676 70.5185L47.3328 58.1014L20.6966 82.1575Z"
        fill="#24BBB1"
      />
      <path
        d="M20.5765 35.2451L39.1742 39.6237L43.2534 18.5077C40.7339 16.588 37.6133 15.5082 34.3739 15.5082C26.3354 15.5082 19.7367 22.0476 19.7367 30.1455C19.6773 31.9451 19.9766 33.6854 20.5765 35.2451Z"
        fill="#EF5098"
      />
      <path
        d="M18.9573 39.6843C10.6777 42.3832 4.85938 50.3623 4.85938 59.1206C4.85938 67.639 10.1384 75.2582 18.0569 78.2576L44.0932 54.7421L39.3535 44.5428L18.9573 39.6843Z"
        fill="#17A8E0"
      />
      <path
        d="M80.8669 105.494C83.4458 107.413 86.5059 108.553 89.6859 108.553C97.7244 108.553 104.323 102.014 104.323 93.9153C104.323 92.1156 104.023 90.436 103.423 88.8157L84.8856 84.4965L80.8669 105.494Z"
        fill="#93C83E"
      />
      <path
        d="M84.6456 79.5774L105.043 84.3171C113.381 81.617 119.141 73.6391 119.141 64.8202C119.141 56.3611 113.862 48.6826 105.942 45.6832L79.2466 69.0787L84.6456 79.5774Z"
        fill="#0779A1"
      />
    </svg>
  </div>
);

export default ElasticIcon;